import {
  ChecklistTemplateEntryConditionDropdownEntryType
} from "../../enums/checklist-template/checklist-template-entry-condition.enum";
import {Languages} from "../../../assets/i18n/Languages";
import {ChecklistTemplateEntryPossibleCondition} from "./checklist-template-entry-possible-condition.model";
import {ChecklistTemplateEntryCondition} from "./checklist-template-entry-condition.model";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {ChecklistTemplateEntryConditionOption} from "./checklist-template-entry-condition-option.model";
import {ChecklistEntryType} from "../../enums/checklist-entry/checklist-entry-type.enum";
import {DatePipe} from "@angular/common";
import {ChecklistEntryRenderOption} from "../../enums/checklist-template/checklist-entry-render-option";
import {ChecklistTemplateEntryPossibleConditions} from "./checklist-template-entry-possible-conditions.model";
import {ChecklistEntryDateTimeType} from "../../enums/checklist-entry/checklist-entry-date-time-type.enum";
import { ComparisonOperator } from '../../enums/comparison-operator/comparison-operator.enum';

export class ChecklistTemplateEntryConditionDropdownEntry {

  //region READONLY FIELDS
  private static readonly OUT_OF_RANGES_EN: string = 'Out of ranges';
  private static readonly OUT_OF_RANGES_DE: string = 'Ausserhalb aller Grenzwerte';
  private static readonly BEFORE_PLACEHOLDER: string = 'FROM';
  private static readonly BEFORE_EN: string = 'from';
  private static readonly BEFORE_DE: string = 'von';
  private static readonly AFTER_PLACEHOLDER: string = 'TO';
  private static readonly AFTER_EN: string = 'to';
  private static readonly AFTER_DE: string = 'bis';

  //endregion

  //region FIELDS
  id: string;
  type: ChecklistTemplateEntryConditionDropdownEntryType;
  entryType: ChecklistEntryType;
  icon: IconProp;
  iconColor: string;
  [Languages.EN]: string;
  [Languages.DE]: string;
  //endregion

  //region HELPERS
  static forEntry(
    checklistTemplateEntryId: string,
    conditionReference: string,
    checklistEntryType: ChecklistEntryType
  ): ChecklistTemplateEntryConditionDropdownEntry {
    const checklistTemplateEntryConditionEntity: ChecklistTemplateEntryConditionDropdownEntry
      = new ChecklistTemplateEntryConditionDropdownEntry();

    checklistTemplateEntryConditionEntity.type = ChecklistTemplateEntryConditionDropdownEntryType.ENTRY;
    checklistTemplateEntryConditionEntity.id = checklistTemplateEntryId;
    checklistTemplateEntryConditionEntity[Languages.EN]
      = '' + conditionReference;
    checklistTemplateEntryConditionEntity[Languages.DE]
      = '' + conditionReference;
    checklistTemplateEntryConditionEntity.entryType = checklistEntryType;

    return checklistTemplateEntryConditionEntity;
  }

  static forPossibleCondition(
    condition: ChecklistTemplateEntryPossibleCondition,
    sourceEntry: ChecklistTemplateEntryPossibleConditions
  ): ChecklistTemplateEntryConditionDropdownEntry {
    const checklistTemplateEntryConditionEntity: ChecklistTemplateEntryConditionDropdownEntry
      = new ChecklistTemplateEntryConditionDropdownEntry();

    if (condition.checklistTemplateEntryOptionId !== null) {
      checklistTemplateEntryConditionEntity.id = condition.checklistTemplateEntryOptionId;
      checklistTemplateEntryConditionEntity[Languages.EN]
        = condition.optionName.translations[Languages.EN];
      checklistTemplateEntryConditionEntity[Languages.DE]
        = condition.optionName.translations[Languages.DE];
      checklistTemplateEntryConditionEntity.type = sourceEntry.renderType === ChecklistEntryType.ASSESSMENT_LIST
        ? checklistTemplateEntryConditionEntity.type = ChecklistTemplateEntryConditionDropdownEntryType.ASSESSMENT
        : ChecklistTemplateEntryConditionDropdownEntryType.OPTION;
      if (!!condition.optionOverallAssessment) {
        checklistTemplateEntryConditionEntity.icon = [
          condition.optionOverallAssessment.iconPrefix,
          condition.optionOverallAssessment.icon
        ] as IconProp;
        checklistTemplateEntryConditionEntity.iconColor
          = condition.optionOverallAssessment.color;
      }
    } else if (condition.checklistTemplateEntryRangeId !== null) {
      checklistTemplateEntryConditionEntity.id = condition.checklistTemplateEntryRangeId;
      checklistTemplateEntryConditionEntity.type = ChecklistTemplateEntryConditionDropdownEntryType.RANGE;

      let rangeLabel: string;
      if (sourceEntry.renderType === ChecklistEntryType.DATE) {
        const datePipe = new DatePipe('de');
        let format = '';
        if (sourceEntry.renderOption === ChecklistEntryRenderOption.DATE) {
          format = 'dd.MM.yyyy';
        } else if (sourceEntry.renderOption === ChecklistEntryRenderOption.DATE_AND_TIME) {
          format = 'dd.MM.yyyy HH:mm';
        } else if (sourceEntry.renderOption === ChecklistEntryRenderOption.TIME) {
          format = 'HH:mm';
        }

        if (condition.range?.lowerLimit != null
          && condition.range?.upperLimit != null) {
          rangeLabel =
            this.BEFORE_PLACEHOLDER
            + ' '
            + datePipe.transform(condition.range?.lowerLimit, format)
            + ' '
            + (condition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + this.AFTER_PLACEHOLDER
            + ' '
            + (condition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + datePipe.transform(condition.range?.upperLimit, format);
        } else if (condition.range?.lowerLimit != null) {
          rangeLabel =
            this.BEFORE_PLACEHOLDER
            + ' '
            + datePipe.transform(condition.range?.lowerLimit, format)
            + ' '
            + (condition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<');
        } else if (condition.range?.upperLimit != null) {
          rangeLabel =
            this.AFTER_PLACEHOLDER
            + ' '
            + (condition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + datePipe.transform(condition.range?.upperLimit, format);
        } else {
          rangeLabel = null;
        }

      } else {
        if (condition.range?.lowerLimit != null
          && condition.range?.upperLimit != null) {
          rangeLabel =
            this.BEFORE_PLACEHOLDER
            + ' '
            + condition.range?.lowerLimit
            + ' '
            + (condition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + this.AFTER_PLACEHOLDER
            + ' '
            + (condition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + condition.range?.upperLimit;
        } else if (condition.range?.lowerLimit != null) {
          rangeLabel =
            this.BEFORE_PLACEHOLDER
            + ' '
            + condition.range?.lowerLimit
            + ' '
            + (condition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<');
        } else if (condition.range?.upperLimit != null) {
          rangeLabel =
            this.AFTER_PLACEHOLDER
            + ' '
            + (condition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
            + ' '
            + condition.range?.upperLimit;
        } else {
          rangeLabel = null;
        }
      }

      let deLabel: string = rangeLabel
        ? rangeLabel.replace(this.BEFORE_PLACEHOLDER, this.BEFORE_DE).replace(this.AFTER_PLACEHOLDER, this.AFTER_DE)
        : this.OUT_OF_RANGES_DE;
      deLabel = deLabel.charAt(0).toUpperCase() + deLabel.slice(1);

      let enLabel: string = rangeLabel
        ? rangeLabel.replace(this.BEFORE_PLACEHOLDER, this.BEFORE_EN).replace(this.AFTER_PLACEHOLDER, this.AFTER_EN)
        : this.OUT_OF_RANGES_EN;
      enLabel = enLabel.charAt(0).toUpperCase() + enLabel.slice(1);

      if (!!condition?.range?.overallAssessment) {
        checklistTemplateEntryConditionEntity.icon = [
          condition.range.overallAssessment.iconPrefix,
          condition.range.overallAssessment.icon
        ] as IconProp;
        checklistTemplateEntryConditionEntity.iconColor
          = condition.range.overallAssessment.color;

        deLabel = deLabel
          + ' ('
          + condition.range.overallAssessment.nameCV.translations[Languages.DE]
          + ')';

        enLabel = enLabel
          + ' ('
          + condition.range.overallAssessment.nameCV.translations[Languages.EN]
          + ')';
      }

      checklistTemplateEntryConditionEntity[Languages.DE] = deLabel;
      checklistTemplateEntryConditionEntity[Languages.EN] = enLabel;
    }

    return checklistTemplateEntryConditionEntity;
  }

  static forConditionOption(
    checklistTemplateEntryConditionOption: ChecklistTemplateEntryConditionOption,
    sourceEntryRenderType: ChecklistEntryType
  ): ChecklistTemplateEntryConditionDropdownEntry {
    const checklistTemplateEntryConditionEntity: ChecklistTemplateEntryConditionDropdownEntry
      = new ChecklistTemplateEntryConditionDropdownEntry();

    checklistTemplateEntryConditionEntity.id = checklistTemplateEntryConditionOption.checklistTemplateEntryOptionId;
    checklistTemplateEntryConditionEntity[Languages.EN]
      = checklistTemplateEntryConditionOption.name.translations[Languages.EN];
    checklistTemplateEntryConditionEntity[Languages.DE]
      = checklistTemplateEntryConditionOption.name.translations[Languages.DE];
    checklistTemplateEntryConditionEntity.type = sourceEntryRenderType === ChecklistEntryType.ASSESSMENT_LIST
      ? checklistTemplateEntryConditionEntity.type = ChecklistTemplateEntryConditionDropdownEntryType.ASSESSMENT
      : ChecklistTemplateEntryConditionDropdownEntryType.OPTION;

    if (!!checklistTemplateEntryConditionOption.overallAssessment) {
      checklistTemplateEntryConditionEntity.icon = [
        checklistTemplateEntryConditionOption.overallAssessment.iconPrefix,
        checklistTemplateEntryConditionOption.overallAssessment.icon
      ] as IconProp;
      checklistTemplateEntryConditionEntity.iconColor
        = checklistTemplateEntryConditionOption.overallAssessment.color;
    }

    return checklistTemplateEntryConditionEntity;
  }

  static forConditionRange(
    checklistTemplateEntryCondition: ChecklistTemplateEntryCondition
  ): ChecklistTemplateEntryConditionDropdownEntry {
    const checklistTemplateEntryConditionEntity: ChecklistTemplateEntryConditionDropdownEntry
      = new ChecklistTemplateEntryConditionDropdownEntry();

    checklistTemplateEntryConditionEntity.id = checklistTemplateEntryCondition.checklistTemplateEntryRangeId;
    checklistTemplateEntryConditionEntity.type = ChecklistTemplateEntryConditionDropdownEntryType.RANGE;

    let rangeLabel;

    if (checklistTemplateEntryCondition.sourceEntryRenderType === ChecklistEntryType.DATE) {
      if (checklistTemplateEntryCondition.range?.lowerLimit != null
        && checklistTemplateEntryCondition.range?.upperLimit != null) {
        rangeLabel =
          this.BEFORE_PLACEHOLDER
          + ' '
          + this.getConditionRangeTextValue(checklistTemplateEntryCondition, checklistTemplateEntryCondition.range?.lowerLimit, true, this.BEFORE_EN, 'en')
          + ' '
          + (checklistTemplateEntryCondition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + this.AFTER_PLACEHOLDER
          + ' '
          + (checklistTemplateEntryCondition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + this.getConditionRangeTextValue(checklistTemplateEntryCondition, checklistTemplateEntryCondition.range?.upperLimit, true, this.BEFORE_EN, 'en');
      } else if (checklistTemplateEntryCondition.range?.lowerLimit != null) {
        rangeLabel =
          this.BEFORE_PLACEHOLDER
          + ' '
          + this.getConditionRangeTextValue(checklistTemplateEntryCondition, checklistTemplateEntryCondition.range?.lowerLimit, true, this.BEFORE_EN, 'en')
          + ' '
          + (checklistTemplateEntryCondition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<');
      } else if (checklistTemplateEntryCondition.range?.upperLimit != null) {
        rangeLabel =
          this.AFTER_PLACEHOLDER
          + ' '
          + (checklistTemplateEntryCondition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + this.getConditionRangeTextValue(checklistTemplateEntryCondition, checklistTemplateEntryCondition.range?.upperLimit, true, this.BEFORE_EN, 'en');
      } else {
        rangeLabel = null;
      }
    } else {

      if (checklistTemplateEntryCondition.range?.lowerLimit != null
        && checklistTemplateEntryCondition.range?.upperLimit != null) {
        rangeLabel =
          this.BEFORE_PLACEHOLDER
          + ' '
          + checklistTemplateEntryCondition.range?.lowerLimit
          + ' '
          + (checklistTemplateEntryCondition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + this.AFTER_PLACEHOLDER
          + ' '
          + (checklistTemplateEntryCondition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + checklistTemplateEntryCondition.range?.upperLimit;
      } else if (checklistTemplateEntryCondition.range?.lowerLimit != null) {
        rangeLabel =
          this.BEFORE_PLACEHOLDER
          + ' '
          + checklistTemplateEntryCondition.range?.lowerLimit
          + ' '
          + (checklistTemplateEntryCondition.range?.lowerLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<');
      } else if (checklistTemplateEntryCondition.range?.upperLimit != null) {
        rangeLabel =
          this.AFTER_PLACEHOLDER
          + ' '
          + (checklistTemplateEntryCondition.range?.upperLimitComparisonOperator === ComparisonOperator.LESS_THAN_OR_EQUAL ? '≤' : '<')
          + ' '
          + checklistTemplateEntryCondition.range?.upperLimit;
      } else {
        rangeLabel = null;
      }
    }

    let deLabel: string = rangeLabel
      ? rangeLabel.replace(this.BEFORE_PLACEHOLDER, this.BEFORE_DE).replace(this.AFTER_PLACEHOLDER, this.AFTER_DE)
      : this.OUT_OF_RANGES_DE;
    deLabel = deLabel.charAt(0).toUpperCase() + deLabel.slice(1);

    let enLabel: string = rangeLabel
      ? rangeLabel.replace(this.BEFORE_PLACEHOLDER, this.BEFORE_EN).replace(this.AFTER_PLACEHOLDER, this.AFTER_EN)
      : this.OUT_OF_RANGES_EN;
    enLabel = enLabel.charAt(0).toUpperCase() + enLabel.slice(1);

    checklistTemplateEntryConditionEntity[Languages.DE] = deLabel;
    checklistTemplateEntryConditionEntity[Languages.EN] = enLabel;

    if (!!checklistTemplateEntryCondition?.range?.overallAssessment) {
      checklistTemplateEntryConditionEntity.icon = [
        checklistTemplateEntryCondition.range.overallAssessment.iconPrefix,
        checklistTemplateEntryCondition.range.overallAssessment.icon
      ] as IconProp;
      checklistTemplateEntryConditionEntity.iconColor
        = checklistTemplateEntryCondition.range.overallAssessment.color;

      deLabel = deLabel
        + ' ('
        + checklistTemplateEntryCondition.range.overallAssessment.nameCV.translations[Languages.DE]
        + ')';

      enLabel = enLabel
        + ' ('
        + checklistTemplateEntryCondition.range.overallAssessment.nameCV.translations[Languages.EN]
        + ')';
    }

    checklistTemplateEntryConditionEntity[Languages.DE] = deLabel;
    checklistTemplateEntryConditionEntity[Languages.EN] = enLabel;

    return checklistTemplateEntryConditionEntity;
  }

  static getConditionRangeTextValue(
    condition: ChecklistTemplateEntryCondition, prop: number, isDate: boolean, text: string, lang: string
  ): string {
    const value = isDate ? prop : prop;

    if (value && isDate) {

      let label = '';
      if (condition.sourceEntryDateTimeType === ChecklistEntryDateTimeType.RELATIVE) {

        label += text + ': ' + value + ' ' + condition.sourceEntryDateTimeDuration;
      } else {
        let format = '';
        if (condition.sourceEntryRenderOption === ChecklistEntryRenderOption.DATE) {
          format = 'dd.MM.yyyy';
        } else if (condition.sourceEntryRenderOption === ChecklistEntryRenderOption.DATE_AND_TIME) {
          format = 'dd.MM.yyyy HH:mm';
        } else if (condition.sourceEntryRenderOption === ChecklistEntryRenderOption.TIME) {
          format = 'HH:mm';
        }
        const datePipe = new DatePipe(lang);
        label = datePipe.transform(value, format);
      }
      return label;
    }

    return null;
  }

  //endregion
}
